import { ChiefBridge } from "../../libs/chief-bridge";

export interface NativeOutgoingMessage {
  [key: string]: unknown;
  Route_HomePage: never;
  startAppLoading: never;
  openLink: {
    linkType: number;
    linkUrl: string;
  };
  share: {
    type: string;
    base64Image: string;
  };
}

export const bridge = new ChiefBridge<NativeOutgoingMessage>("lottery", true);
